exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../assets/bg.png"));

// Module
exports.push([module.id, "#app[data-v-ab1234e2] {\n  overflow: hidden;\n  background-color: #35008b;\n}\n#app .bgWrap[data-v-ab1234e2] {\n  background: url(" + ___CSS_LOADER_URL___0___ + ");\n  background-size: 20rem auto;\n}\n", ""]);

